import factory from './icon';
import Svg from './glyphs/zoom-in.svg';

export default factory(Svg);
